import { useEffect } from 'react';
import Lenis from 'lenis';
import {
  clearUrlHash,
  getHeaderOffsetPx,
  handleInitialHashScroll,
  scrollToSection,
  setLenisInstance,
} from '../utils/sectionNav';

export function useSmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => 1 - (1 - t) ** 3,
      smoothWheel: true,
      touchMultiplier: 1.35,
    });

    setLenisInstance(lenis);

    let frameId = 0;

    const onFrame = (time) => {
      lenis.raf(time);
      frameId = requestAnimationFrame(onFrame);
    };

    frameId = requestAnimationFrame(onFrame);

    const onSectionClick = (event) => {
      const sectionId = event.currentTarget.getAttribute('data-section');
      if (!sectionId) {
        return;
      }

      event.preventDefault();
      scrollToSection(sectionId, { offset: getHeaderOffsetPx() });
    };

    const onLegacyAnchorClick = (event) => {
      const href = event.currentTarget.getAttribute('href');
      if (!href?.startsWith('#') || href.length <= 1) {
        return;
      }

      event.preventDefault();
      scrollToSection(href.slice(1), { offset: getHeaderOffsetPx() });
    };

    const sectionLinks = document.querySelectorAll('[data-section]');
    sectionLinks.forEach((link) => link.addEventListener('click', onSectionClick));

    const legacyAnchors = document.querySelectorAll('a[href^="#"]');
    legacyAnchors.forEach((anchor) => anchor.addEventListener('click', onLegacyAnchorClick));

    handleInitialHashScroll();

    const onHashChange = () => clearUrlHash();
    window.addEventListener('hashchange', onHashChange);

    return () => {
      cancelAnimationFrame(frameId);
      sectionLinks.forEach((link) => link.removeEventListener('click', onSectionClick));
      legacyAnchors.forEach((anchor) => anchor.removeEventListener('click', onLegacyAnchorClick));
      window.removeEventListener('hashchange', onHashChange);
      setLenisInstance(null);
      lenis.destroy();
    };
  }, []);
}
